var lib_core = require("lib-core");
var _        = require('underscore');

var SwitcherView         = require("./switcherView.js");
var SwitcherModel        = require("./switcherModel.js");
var SwitcherStateMachine = require("./switcherStateMachine.js");

var SwitcherController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        SWITCHER_CLICK:  {id: 'swtchr_1', name: "SWITCHER_CLICK",  isGuiButton: true },
        SWITCHER_DELETE: {id: 'swtchr_2', name: "SWITCHER_DELETE", isGuiButton: false }
    });
};
lib_core.inherit(SwitcherController, lib_core.Controller);

module.exports = SwitcherController;

SwitcherController.prototype.createView = function () {
    var parentView = this.parent().getView();

    return new SwitcherView(this.getModel(), this.getStatemachine(), parentView, this.name(), this.configuration.theme, this.configuration.multiLevelStyle, this.configuration);
};

SwitcherController.prototype.createModel = function () {
    // this is evil!
    var configuration = {
        collections: this.configuration.collection[0] instanceof Array ? this.configuration.collection : [this.configuration.collection],
        readOnlyLevel: this.configuration.readOnlyLevel != undefined ? this.configuration.readOnlyLevel : Infinity
    } ;
    var collection = this.root.findByPath(configuration.collections[0]);
    return new SwitcherModel(this.root, configuration, collection, this.configuration);
};

SwitcherController.prototype.createStateMachine = function () {
    return new SwitcherStateMachine(this.root, this.getModel());
};